module.exports = __webpack_public_path__ + "static/media/Package-02.3728c62d.png";